import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

const APOutlineButton = ({
  text,
  onClick,
  color = "primary",
  animateOnRender,
  startAdornment,
  endAdornment,
}: {
  text: string;
  color: "primary" | "secondary" | "tertiaryGreen";
  onClick?: () => void;
  animateOnRender?: boolean;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
}) => {
  return (
    <Box
      sx={{
        border: "2px solid",
        borderColor: `${color}.main`,
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        transition: animateOnRender ? "all 0.3s ease" : undefined,
        animation: animateOnRender ? "pulse-glow 2s 2" : undefined,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: 1,
          flex: 1,
          cursor: "pointer",
          p: 1.5,
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 26,
          }}
        >
          {startAdornment}
        </Box>
        <Typography variant="titleMedium">{text}</Typography>
      </Box>
      {endAdornment && (
        <Box p={1.5} ml={2}>
          {endAdornment}
        </Box>
      )}
    </Box>
  );
};

export default APOutlineButton;
